import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater } from 'components'

// 메인
import Life from './home'
import LifeErrorCommon from './LifeErrorCommon'

// 커리어
import CareerIntro from './CareerIntro'
import CareerSecurity from './CareerSecurity'
import CertiManage from './CertiManage'
import CertiBring from './CertiBring'
import CertImport from './CertImport'
import CareerResult from './CareerResult'
import CareerResultNone from './CareerResultNone'
import CareerCompanySearch from './CareerCompanySearch'
import CareerResultError1 from './CareerResultError1'
import CareerResultError2 from './CareerResultError2'
import CareerResultError3 from './CareerResultError3'
import CareerIncome from './CareerIncome'
import CareerIncomeDetails1 from './CareerIncomeDetails1'
import CareerIncomeDetails2 from './CareerIncomeDetails2'
import CareerIncomeDetails3 from './CareerIncomeDetails3'

// 패밀리
import FamilyIntro from './FamilyIntro'
import FamilySecurity from './FamilySecurity'
import FamilyResult from './FamilyResult'

// 정부지원금
import GrantIntro from './GrantIntro'
import GrantSecurity from './GrantSecurity'
import GrantLoading from './GrantLoading'
import GrantError from './GrantError'
import GrantList from './GrantList'
import GrantModify from './GrantModify'
import GrantDetails1 from './GrantDetails1'
import GrantDetails2 from './GrantDetails2'
import GrantDetails3 from './GrantDetails3'

// 내 차 보기
import MyCarEnter from './MyCarEnter'
import MyCarSelect from './MyCarSelect'
import MyCarMain from './MyCarMain'
import MyCarMainNone from './MyCarMainNone'
import MyCarDetail from './MyCarDetail'
import MyCarInspection from './MyCarInspection'
import MyCarInfo1 from './MyCarInfo1'
import MyCarInfo2 from './MyCarInfo2'
import MyCarLayer from './MyCarLayer'
import MyCarRecall from './MyCarRecall'
import MyCarRecallDetail from './MyCarRecallDetail'
import MyCarRepair from './MyCarRepair'

// 내 집 보기
import HomeMain from './HomeMain'
import HomeSelect from './HomeSelect'
import HomeSearch1 from './HomeSearch1'
import HomeSearch2 from './HomeSearch2'
import HomeEnter from './HomeEnter'
import HomeDetailNone from './HomeDetailNone'
import HomeDetailSale from './HomeDetailSale'
import HomeDetailRent from './HomeDetailRent'
import HomeDetailNeighborhoodSale from './HomeDetailNeighborhoodSale'
import HomeDetailNeighborhoodRent from './HomeDetailNeighborhoodRent'
import HomeModify from './HomeModify'

// 회사조회
import CompanyMain from './CompanyMain'
import CompanySearch from './CompanySearch'
import CompanySearchNone from './CompanySearchNone'
import CompanyDetail1 from './CompanyDetail1'
import CompanyDetail2 from './CompanyDetail2'

// 학교조회
import SchoolMain from './SchoolMain'
import SchoolSearch from './SchoolSearch'
import SchoolSearchNone from './SchoolSearchNone'
import SchoolDetail1 from './SchoolDetail1'
import SchoolDetail2 from './SchoolDetail2'
import SchoolDetail3 from './SchoolDetail3'

// 여행
import TravelMain from './TravelMain'
import TravelSearch from './TravelSearch'
import TravelSearchResult from './TravelSearchResult'
import TravelSelect from './TravelSelect'
import TravelDetail1 from './TravelDetail1'
import TravelDetail2 from './TravelDetail2'
import TravelDetail3 from './TravelDetail3'
import TravelDetail4 from './TravelDetail4'
import TravelDetail5 from './TravelDetail5'
import TravelDetail6 from './TravelDetail6'
import TravelDetail7 from './TravelDetail7'
import TravelDetail8 from './TravelDetail8'

// life
const Index = () => {

	return (
		<>
			<Floater>
				<li><Link to="careerIntro">커리어 소개페이지</Link></li>
				<li><Link to="careerSecurity">커리어 주민등록번호 입력</Link></li>
				<li><Link to="certiManage">커리어 공동인증서</Link></li>
				<li><Link to="careerResult">커리어 결과(공통)</Link></li>
				<li><Link to="careerResultNone">커리어 결과(데이터 없는 경우)</Link></li>
				<li><Link to="careerCompanySearch">커리어 결과(회사조회)</Link></li>
				<li><Link to="careerResultError1">커리어 결과 에러 1</Link></li>
				<li><Link to="careerResultError2">커리어 결과 에러 2</Link></li>
				<li><Link to="careerResultError3">커리어 결과 에러 3</Link></li>
				<li><Link to="careerIncome">커리어 소득정보 더보기</Link></li>
				<li><Link to="careerIncomeDetails1">커리어 소득정보 상세보기 (지역가입자)</Link></li>
				<li><Link to="careerIncomeDetails2">커리어 소득정보 상세보기 (직장가입자 직장1개)</Link></li>
				<li><Link to="careerIncomeDetails3">커리어 소득정보 상세보기 (직장가입자 직장 여러 개)</Link></li>
				<li><Link to="familyIntro">패밀리 소개페이지</Link></li>
				<li><Link to="familySecurity">패밀리 거주지 및 주민번호 입력</Link></li>
				<li><Link to="familyResult">패밀리 결과</Link></li>
				<li><Link to="grantIntro">정부지원금 소개페이지</Link></li>
				<li><Link to="grantSecurity">정부지원금 거주지 및 주민번호 입력</Link></li>
				<li><Link to="grantLoading">정부지원금 로딩</Link></li>
				<li><Link to="grantError">정부지원금 실패</Link></li>
				<li><Link to="grantList">정부지원금 목록</Link></li>
				<li><Link to="grantModify">정부지원금 조건변경</Link></li>
				<li><Link to="grantDetails1">정부지원금 상세보기 (지자체지원금)</Link></li>
				<li><Link to="grantDetails2">정부지원금 상세보기 (복지로)</Link></li>
				<li><Link to="grantDetails3">정부지원금 상세보기 (보조금24)</Link></li>
				<li><Link to="myCarEnter">내 차 보기 차량등록</Link></li>
				<li><Link to="myCarSelect">내 차 보기 내 차 선택</Link></li>
				<li><Link to="myCarMain">내 차 보기 메인</Link></li>
				<li><Link to="myCarMainNone">내 차 보기 메인 (데이터 없을 때)</Link></li>
				<li><Link to="myCarDetail">내 차 보기 내 차 상세</Link></li>
				<li><Link to="myCarInspection">내 차 보기 검사소 찾기</Link></li>
				<li><Link to="myCarInfo1">내 차 보기 내차상세 (기본정보)</Link></li>
				<li><Link to="myCarInfo2">내 차 보기 내차상세 (출고옵션)</Link></li>
				<li><Link to="myCarLayer">내 차 보기 자동차등록원부 보기</Link></li>
				<li><Link to="myCarRecall">내 차 보기 리콜정보</Link></li>
				<li><Link to="myCarRecallDetail">내 차 보기 리콜정보 상세</Link></li>
				<li><Link to="myCarRepair">내 차 보기 수리정비내역</Link></li>
				<li><Link to="homeMain">내 집 보기 메인</Link></li>
				<li><Link to="homeSelect">내 집 보기 유형선택</Link></li>
				<li><Link to="homeSearch1">내 집 보기 주소입력 전</Link></li>
				<li><Link to="homeSearch2">내 집 보기 주소입력 후</Link></li>
				<li><Link to="homeEnter">내 집 보기 등록</Link></li>
				<li><Link to="homeDetailNone">내 집 보기 상세 (데이터 없을 때)</Link></li>
				<li><Link to="homeDetailSale">내 집 보기 상세 (매매)</Link></li>
				<li><Link to="homeDetailRent">내 집 보기 상세 (월세)</Link></li>
				<li><Link to="homeDetailNeighborhoodSale">내 집 보기 상세 우리동네 (매매)</Link></li>
				<li><Link to="homeDetailNeighborhoodRent">내 집 보기 상세 우리동네 (월세)</Link></li>
				<li><Link to="homeModify">내 집 보기 수정</Link></li>
				<li><Link to="companyMain">회사조회 메인</Link></li>
				<li><Link to="companySearch">회사조회 회사명 검색</Link></li>
				<li><Link to="companySearchNone">회사조회 회사명 검색 (데이터 없음)</Link></li>
				<li><Link to="companyDetail1">회사조회 상세 (기업정보)</Link></li>
				<li><Link to="companyDetail2">회사조회 상세 (재무정보)</Link></li>
				<li><Link to="schoolMain">학교조회 메인</Link></li>
				<li><Link to="schoolSearch">학교조회 검색</Link></li>
				<li><Link to="schoolSearchNone">학교조회 검색 (데이터 없음)</Link></li>
				<li><Link to="schoolDetail1">학교조회 상세 (어린이집)</Link></li>
				<li><Link to="schoolDetail2">학교조회 상세 (유치원)</Link></li>
				<li><Link to="schoolDetail3">학교조회 상세 (초등학교)</Link></li>
				<li><Link to="travelMain">여행 여행정보</Link></li>
				<li><Link to="travelSearch">여행 검색</Link></li>
				<li><Link to="travelSearchResult">여행 검색결과</Link></li>
				<li><Link to="travelSelect">여행 목록(선택)</Link></li>
				<li><Link to="travelDetail1">여행 여행정보 상세 (관광지)</Link></li>
				<li><Link to="travelDetail2">여행 여행정보 상세 (문화시설)</Link></li>
				<li><Link to="travelDetail3">여행 여행정보 상세 (축제・행사)</Link></li>
				<li><Link to="travelDetail4">여행 여행정보 상세 (레포츠)</Link></li>
				<li><Link to="travelDetail5">여행 여행정보 상세 (쇼핑)</Link></li>
				<li><Link to="travelDetail6">여행 여행정보 상세 (음식)</Link></li>
				<li><Link to="travelDetail7">여행 여행정보 상세 (숙박)</Link></li>
				<li><Link to="travelDetail8">여행 여행정보 상세 (여행코스)</Link></li>
				<li><Link to="lifeErrorCommon">결과 에러(공통)</Link></li>
				<li><Link to="">라이프 메인</Link></li>
			</Floater>
			<Routes>
				<Route path="/careerIntro" element={<CareerIntro />} /> { /* 커리어 소개페이지 */}
				<Route path="/careerSecurity" element={<CareerSecurity />} /> { /* 커리어 주민등록번호 입력 */}
				<Route path="/certiManage" element={<CertiManage />} /> { /* 커리어 공동인증서 */}
				{/* <Route path="/certImport" element={<CertImport />} /> */} { /* 공동인증서 가져오기 */}
				{/* <Route path="/certiBring" element={<CertiBring />} /> { /* 공동인증서 가져오기 */}
				<Route path="/careerResult" element={<CareerResult />} /> { /* 커리어 결과(공통) */}
				<Route path="/careerResultNone" element={<CareerResultNone />} /> { /* 커리어 결과(데이터 없는 경우) */}
				<Route path="/careerCompanySearch" element={<CareerCompanySearch />} /> { /* 커리어 결과(회사조회) */}
				<Route path="/careerResultError1" element={<CareerResultError1 />} /> { /* 커리어 결과 에러 1 */}
				<Route path="/careerResultError2" element={<CareerResultError2 />} /> { /* 커리어 결과 에러 1 */}
				<Route path="/careerResultError3" element={<CareerResultError3 />} /> { /* 커리어 결과 에러 1 */}
				<Route path="/careerIncome" element={<CareerIncome />} /> { /* 커리어 소득정보 더보기 */}
				<Route path="/careerIncomeDetails1" element={<CareerIncomeDetails1 />} /> { /* 커리어 소득정보 상세보기 (지역가입자) */}
				<Route path="/careerIncomeDetails2" element={<CareerIncomeDetails2 />} /> { /* 커리어 소득정보 상세보기 (직장가입자 직장1개) */}
				<Route path="/careerIncomeDetails3" element={<CareerIncomeDetails3 />} /> { /* 커리어 소득정보 상세보기 (직장가입자 직장 여러 개) */}

				<Route path="/familyIntro" element={<FamilyIntro />} /> { /* 패밀리 소개페이지 */}
				<Route path="/familySecurity" element={<FamilySecurity />} /> { /* 패밀리 거주지 및 주민번호 입력 */}
				<Route path="/familyResult" element={<FamilyResult />} /> { /* 패밀리 결과 */}

				<Route path="/grantIntro" element={<GrantIntro />} /> { /* 정부지원금 소개페이지 */}
				<Route path="/grantSecurity" element={<GrantSecurity />} /> { /* 정부지원금 거주지 및 주민번호 입력 */}
				<Route path="/grantLoading" element={<GrantLoading />} /> { /* 정부지원금 로딩 */}
				<Route path="/grantError" element={<GrantError />} /> { /* 정부지원금 실패 */}
				<Route path="/grantList" element={<GrantList />} /> { /* 정부지원금 목록 */}
				<Route path="/grantModify" element={<GrantModify />} /> { /* 정부지원금 조건변경 */}
				<Route path="/grantDetails1" element={<GrantDetails1 />} /> { /* 정부지원금 상세보기 (지자체지원금) */}
				<Route path="/grantDetails2" element={<GrantDetails2 />} /> { /* 정부지원금 상세보기 (복지로) */}
				<Route path="/grantDetails3" element={<GrantDetails3 />} /> { /* 정부지원금 상세보기 (보조금24) */}

				<Route path="/myCarEnter" element={<MyCarEnter />} /> { /* 내 차 보기 차량등록 */}
				<Route path="/myCarSelect" element={<MyCarSelect />} /> { /* 내 차 보기 내 차 선택 */}
				<Route path="/myCarMain" element={<MyCarMain />} /> { /* 내 차 보기 메인 */}
				<Route path="/myCarMainNone" element={<MyCarMainNone />} /> { /* 내 차 보기 메인 (데이터 없을 때) */}
				<Route path="/myCarDetail" element={<MyCarDetail />} /> { /* 내 차 보기 내 차 상세 */}
				<Route path="/myCarInspection" element={<MyCarInspection />} /> { /* 내 차 보기 검사소 찾기 */}
				<Route path="/myCarInfo1" element={<MyCarInfo1 />} /> { /* 내 차 보기 내차상세 (기본정보) */}
				<Route path="/myCarInfo2" element={<MyCarInfo2 />} /> { /* 내 차 보기 내차상세 (출고옵션) */}
				<Route path="/myCarLayer" element={<MyCarLayer />} /> { /* 내 차 보기 자동차등록원부 보기 */}
				<Route path="/myCarRecall" element={<MyCarRecall />} /> { /* 내 차 보기 리콜정보 */}
				<Route path="/myCarRecallDetail" element={<MyCarRecallDetail />} /> { /* 내 차 보기 리콜정보 상세 */}
				<Route path="/myCarRepair" element={<MyCarRepair />} /> { /* 내 차 보기 수리정비내역 */}

				<Route path="/homeMain" element={<HomeMain />} /> { /* 내 집 보기 메인 */}
				<Route path="/homeSelect" element={<HomeSelect />} /> { /* 내 집 보기 유형선택 */}
				<Route path="/homeSearch1" element={<HomeSearch1 />} /> { /* 내 집 보기 주소입력 전 */}
				<Route path="/homeSearch2" element={<HomeSearch2 />} /> { /* 내 집 보기 주소입력 후 */}
				<Route path="/homeEnter" element={<HomeEnter />} /> { /* 내 집 보기 등록 */}
				<Route path="/homeDetailNone" element={<HomeDetailNone />} /> { /* 내 집 보기 상세 (데이터 없을 때) */}
				<Route path="/homeDetailSale" element={<HomeDetailSale />} /> { /* 내 집 보기 상세 (매매) */}
				<Route path="/homeDetailRent" element={<HomeDetailRent />} /> { /* 내 집 보기 상세 (월세) */}
				<Route path="/homeDetailNeighborhoodSale" element={<HomeDetailNeighborhoodSale />} /> { /* 내 집 보기 상세 우리동네 (매매) */}
				<Route path="/homeDetailNeighborhoodRent" element={<HomeDetailNeighborhoodRent />} /> { /* 내 집 보기 상세 우리동네 (월세) */}
				<Route path="/homeModify" element={<HomeModify />} /> { /* 내 집 보기 수정 */}

				<Route path="/companyMain" element={<CompanyMain />} /> { /* 회사조회 메인 */}
				<Route path="/companySearch" element={<CompanySearch />} /> { /* 회사조회 회사명 검색 */}
				<Route path="/companySearchNone" element={<CompanySearchNone />} /> { /* 회사조회 회사명 검색 (데이터 없음) */}
				<Route path="/companyDetail1" element={<CompanyDetail1 />} /> { /* 회사조회 상세 (기업정보) */}
				<Route path="/companyDetail2" element={<CompanyDetail2 />} /> { /* 회사조회 상세 (재무정보) */}

				<Route path="/schoolMain" element={<SchoolMain />} /> { /* 학교조회 메인 */}
				<Route path="/schoolSearch" element={<SchoolSearch />} /> { /* 학교조회 검색 */}
				<Route path="/schoolSearchNone" element={<SchoolSearchNone />} /> { /* 학교조회 검색 (데이터 없음) */}
				<Route path="/schoolDetail1" element={<SchoolDetail1 />} /> { /* 학교조회 상세 (어린이집) */}
				<Route path="/schoolDetail2" element={<SchoolDetail2 />} /> { /* 학교조회 상세 (유치원) */}
				<Route path="/schoolDetail3" element={<SchoolDetail3 />} /> { /* 학교조회 상세 (초등학교) */}

				<Route path="/travelMain" element={<TravelMain />} /> { /* 여행 여행정보 */}
				<Route path="/travelSearch" element={<TravelSearch />} /> { /* 여행 검색 */}
				<Route path="/travelSearchResult" element={<TravelSearchResult />} /> { /* 여행 검색결과 */}
				<Route path="/travelSelect" element={<TravelSelect />} /> { /* 여행 목록(선택) */}
				<Route path="/travelDetail1" element={<TravelDetail1 />} /> { /* 여행 여행정보 상세 (관광지) */}
				<Route path="/travelDetail2" element={<TravelDetail2 />} /> { /* 여행 여행정보 상세 (문화시설) */}
				<Route path="/travelDetail3" element={<TravelDetail3 />} /> { /* 여행 여행정보 상세 (축제・행사) */}
				<Route path="/travelDetail4" element={<TravelDetail4 />} /> { /* 여행 여행정보 상세 (레포츠) */}
				<Route path="/travelDetail5" element={<TravelDetail5 />} /> { /* 여행 여행정보 상세 (쇼핑) */}
				<Route path="/travelDetail6" element={<TravelDetail6 />} /> { /* 여행 여행정보 상세 (음식) */}
				<Route path="/travelDetail7" element={<TravelDetail7 />} /> { /* 여행 여행정보 상세 (숙박) */}
				<Route path="/travelDetail8" element={<TravelDetail8 />} /> { /* 여행 여행정보 상세 (여행코스) */}

				<Route path="/lifeErrorCommon" element={<LifeErrorCommon />} /> { /* 결과 에러(공통) */}
				<Route path="/" element={<Life />} /> { /* 라이프 메인 */}
			</Routes>
		</>
	)
}

export default Index